const wantToSeeListener = () => {
    const wantToSeeElements = [...document.querySelectorAll('.js-esalon-want-to-see')].filter(
        (el) => !el.dataset.wantToSeeInitialized
    );

    const bookeroPluginContainer =
        document.querySelector('#bookero-plugin') ??
        document.querySelector('#bookero-form-container');

    wantToSeeElements.forEach((el) => {
        el.addEventListener('click', () => {
            const { model } = el.dataset;

            const bookeroPluginAdditionalInfoField =
                bookeroPluginContainer.querySelector('textarea');

            if (
                bookeroPluginAdditionalInfoField &&
                !bookeroPluginAdditionalInfoField?.value?.includes(model)
            ) {
                bookeroPluginAdditionalInfoField.value += `${
                    bookeroPluginAdditionalInfoField.value.length ? ', ' : ''
                }${model}`;
            }

            el.disabled = true;
        });

        el.dataset.wantToSeeInitialized = true;
    });
};

window.addEventListener('RemoteContentLoaded', () => {
    wantToSeeListener();
});
